import { lazy, Suspense, useMemo } from 'react';
import _ from 'lodash';

const libraryMapping = {
    fa: () => import('react-icons/fa'),
    bs: () => import('react-icons/bs'),
    md: () => import('react-icons/md'),
    io4: () => import('react-icons/io'),
    io: () => import('react-icons/io5'),
    ri: () => import('react-icons/ri'),
    bi: () => import('react-icons/bi'),
    im: () => import('react-icons/im'),
    gr: () => import('react-icons/gr'),
};

export const iconLibraries = {
    'react-icons/fa': {
        library: 'React Icons (FontAwesome)',
        iconsImport: libraryMapping['fa'],
    },
    'react-icons/bs': {
        library: 'React Icons (Bootstrap)',
        iconsImport: libraryMapping['bs'],
    },
    'react-icons/md': {
        library: 'React Icons (Material Design)',
        iconsImport: libraryMapping['md'],
    },
    'react-icons/io4': {
        library: 'React Icons (Ionicons 4)',
        iconsImport: libraryMapping['io4'],
    },
    'react-icons/io5': {
        library: 'React Icons (Ionicons 5)',
        iconsImport: libraryMapping['io'],
    },
    'react-icons/ri': {
        library: 'React Icons (Remix)',
        iconsImport: libraryMapping['ri'],
    },
    'react-icons/bi': {
        library: 'React Icons (Boxicons)',
        iconsImport: libraryMapping['bi'],
    },
    'react-icons/im': {
        library: 'React Icons (IcoMoon)',
        iconsImport: libraryMapping['im'],
    },
    'react-icons/gr': {
        library: 'React Icons (Grommet)',
        iconsImport: libraryMapping['gr'],
    },
};

export const LazyIcon = ({ name, ...props }) => {
    const Icon = useMemo(() => {
        return lazy(async () => {
            // 1. Bepaal de prefix (bijv. 'Fa' van 'FaBeer')
            let prefix = name.substring(0, 2).toLowerCase();

            if (
                _.startsWith(name, 'IoIos') ||
                _.startsWith(name, 'IoMd') ||
                [
                    'IoLogoFreebsdDevil',
                    'IoLogoGameControllerA',
                    'IoLogoGameControllerB',
                    'IoLogoGoogleplus',
                    'IoLogoModelS',
                    'IoLogoPolymer',
                ].includes(name)
            ) {
                prefix = 'io4';
            }

            const importLibrary = libraryMapping[prefix];

            if (!importLibrary) {
                console.error(`Library voor prefix "${prefix}" niet gevonden.`);
                return { default: () => null };
            }

            // 2. Importeer de bibliotheek dynamisch
            const module = await importLibrary();

            // 3. Haal het specifieke icoon uit de module
            const ExportedIcon = module[name];

            if (!ExportedIcon) {
                console.error(`Icoon "${name}" niet gevonden in ${prefix}.`);
                return { default: () => null };
            }

            return { default: ExportedIcon };
        });
    }, [name]);

    return (
        <Suspense fallback={<div style={{ width: '1em', height: '1em' }} />}>
            <Icon {...props} />
        </Suspense>
    );
};
